EtdActions = require 'actions/etd_actions'
EtdEditor = require 'components/etd/etd_editor'
EtdStore = require 'stores/etd_store'
Select = require 'components/common/select_custom'
ConnectStore = require 'components/enhancers/connect_store'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'
{ Button, SelectWithCheckboxes } = ReactComponents
IconButton = require 'components/common/icon_button'
RemarksSection = require 'components/etd/remarks_section'
Translation = require 'components/mixins/translation'

CERTAINTY_PATH = ['templateData', 'assessment', 'criteria', 'certaintyOfEvidence']

SingleRecommendation = createReactClass

  mixins: [CustomRenderMixin, Translation('es:recommendations')]

  onChangeRecommendation: (value) ->
    EtdActions.updateSelectedRecommendationValue {index: @props.index, value}

  onChangeCertainty: (value) ->
    EtdActions.updateSelectedCertaintyValue { index: @props.index, value }

  onRemove: ->
    EtdActions.removeRecommendation @props.index

  render: ->
    {
      certaintyOptions
      editable
      index
      isConsensus
      noAutoSave
      options
      recommendation
      renderMode
      showDeleteButton
      stickControlsTo
    } = @props

    content = recommendation.get('content')
    remarks = recommendation.get('remarks', Immutable.Map())
    selectedCertainty = recommendation.get('selectedCertainty', Immutable.List())
    selectedOption = recommendation.get('selectedOption')

    <div className="multiple-recommendations__single">
      <div className="single__header">
        <div className="header__select-options">
          <div className="mb-5">
            <div className="bold">{@i18n 'strength_of_recommendation'}</div>
            <Select
              options={options}
              selected={selectedOption}
              onChange={@onChangeRecommendation}
            />
          </div>
          <div>
            <div className="bold">{@i18n 'certainty'}</div>
            <SelectWithCheckboxes
              className="w-full"
              onChange={@onChangeCertainty}
              options={certaintyOptions.toJS()}
              selectedOptions={selectedCertainty.toJS() or []}
              withSelectAll={false}
            />
          </div>
        </div>
        {renderMode isnt 'printout' and showDeleteButton and <IconButton
          iconName="decline-icon"
          onClick={@onRemove}
        />}
      </div>
      <EtdEditor
        cellId={"multipleRecommendations_#{index}#conclusionsMultiRecommendations"}
        className="recommendation-editor-container"
        content={content}
        editable={editable}
        isConsensus={isConsensus}
        noAutoSave={noAutoSave}
        noInsertOption
        onSaveContent={EtdActions.updateEditorContent}
        renderMode={renderMode}
        stickControlsTo={stickControlsTo}
      />
      <RemarksSection
        remarks={remarks}
        editable={editable}
        index={index}
        renderMode={renderMode}
        sectionId={"multipleRecommendations"}
      />

    </div>

MultipleRecommendations = createReactClass
  displayName: "MultipleRecommendations"
  propTypes:
    editable: PropTypes.bool
    renderMode: PropTypes.string
    template: PropTypes.instanceOf(Immutable.Map).isRequired

  mixins: [ CustomRenderMixin, Translation() ]

  getDefaultProps: ->
    editable: true
    stickControlsTo: '#recommendations'

  addRecommendation: ->
    EtdActions.addRecommendation()

  render: ->
    { renderMode, editable, section, template } = @props
    options = section.get('options').toJS()
    showDeleteButton = section.get('recommendations').size > 1

    certaintyOptions = template.getIn([CERTAINTY_PATH..., 'options'], Immutable.List())
      .concat(template.getIn([CERTAINTY_PATH..., 'additionalOptions'], Immutable.List()))

    <div>
      {section.get('recommendations').map (recommendation, idx) =>
        <SingleRecommendation
          certaintyOptions={certaintyOptions}
          editable={editable}
          index={idx}
          key={_.uniqueId()}
          options={options}
          recommendation={recommendation}
          renderMode={renderMode}
          showDeleteButton={showDeleteButton}
        />
      }
      {renderMode isnt 'printout' and <p className="text-right">

        <Button onClick={@addRecommendation}>{@i18n 'actions.add_recommendation'}</Button>
      </p>}
    </div>

storeConnector =
  EtdStore: (Store) ->
    template: Store.getTemplate()

module.exports = ConnectStore MultipleRecommendations, EtdStore, storeConnector
